import React, { useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { failed, success } from "../../../utils/Tostify";
import { useNavigate } from "react-router-dom";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import './PurchaseForm.css';
const PurchaseForm = ({ show, handleClose, featureName }) => {
    const navigate = useNavigate();

    const [form, setForm] = useState({
        companyName: "",
        ownerName: "",
        email: "",
        password: "",
        websiteUrl: "",
        phone: "",
        streetAddress: "",
        state: "",
        city: "",
        zip: ""
    });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = () => {
        const {
            companyName,
            ownerName,
            email,
            password,
            websiteUrl,
            phone,
            streetAddress,
            state,
            city,
            zip,
        } = form;
    
        if (!companyName || !ownerName || !email || !password || !websiteUrl || !phone || !streetAddress || !state || !city || !zip) {
            failed("Please fill all the required fields.");
            return;
        }
    
        success("Successful");
        handleClose();
        navigate("/checkout", { state: { featureName } });
    };
    

    return (
        <Modal show={show} onHide={handleClose} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Purchase</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Company Name<span className="text-danger">*</span></Form.Label>
                                <Form.Control type="text" name="companyName" placeholder="Enter Company Name" value={form.companyName} onChange={handleChange} />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Owner Name<span className="text-danger">*</span></Form.Label>
                                <Form.Control type="text" name="ownerName" placeholder="Enter Owner Name" value={form.ownerName} onChange={handleChange} />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Email<span className="text-danger">*</span></Form.Label>
                                <Form.Control type="email" name="email" placeholder="Enter Email" value={form.email} onChange={handleChange} />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Password<span className="text-danger">*</span></Form.Label>
                                <Form.Control type="password" name="password" placeholder="Enter Password" value={form.password} onChange={handleChange} />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Form.Group className="mb-3">
                        <Form.Label>Website URL<span className="text-danger">*</span></Form.Label>
                        <Form.Control type="text" name="websiteUrl" placeholder="Enter Website URL" value={form.websiteUrl} onChange={handleChange} />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Phone<span className="text-danger">*</span></Form.Label>
                        <PhoneInput
                        
                            defaultCountry="in"
                            placeholder="Enter phone number"
                            value={form.phone}
                            onChange={(phone) => setForm({ ...form, phone })}
                        />
                    </Form.Group>



                    <Form.Group className="mb-3">
                        <Form.Label>Street Address<span className="text-danger">*</span></Form.Label>
                        <Form.Control type="text" name="streetAddress" placeholder="Enter Address" value={form.streetAddress} onChange={handleChange} />
                    </Form.Group>

                    <Row>
                        <Col md={4}>
                            <Form.Group className="mb-3">
                                <Form.Label>State<span className="text-danger">*</span></Form.Label>
                                <Form.Control type="text" name="state" placeholder="Enter State" value={form.state} onChange={handleChange} />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group className="mb-3">
                                <Form.Label>City<span className="text-danger">*</span></Form.Label>
                                <Form.Control type="text" name="city" placeholder="Enter City" value={form.city} onChange={handleChange} />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group className="mb-3">
                                <Form.Label>ZIP Code<span className="text-danger">*</span></Form.Label>
                                <Form.Control type="text" name="zip" placeholder="Enter ZIP Code" value={form.zip} onChange={handleChange} />
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="light" onClick={handleClose}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleSubmit}>
                    Next
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PurchaseForm;
